import React from 'react';
import PropTypes from 'prop-types';

import ItemWithImage from '../../../02_molecules/Item/ItemWithImage';
import { PTItemWithImage } from '../../../02_molecules/Item/ItemWithImage/prop-types';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

/**
 * Documents (with previews) body block in Drupal.
 */
const BBResourcesList = ({ items, behaviorSettings = null, uuid = null }) => (
  <div
    className={`bb bb-resources-list ${
      styles['bb-resources-list']
    } ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
    id={uuid}
  >
    <div className="container">
      <div className="row">
        {items.map((item) => {
          if (!item.image) {
            return;
          }
          return (
            <div className="col-12 col-md-6 col-lg-3" key={item.image.fallbackSrc}>
              <ItemWithImage {...item} />
            </div>
          );
        })}
      </div>
    </div>
  </div>
);

BBResourcesList.propTypes = {
  items: PTItemWithImage.isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBResourcesList;
